import {
	useInfiniteQuery,
	type InfiniteData,
	type UseInfiniteQueryOptions,
} from '@tanstack/react-query';
import {
	getAttributeVocabularyValues,
	getAttributeVocabularyValuesEndpoint,
	type QueryError,
	type GetAttributeVocabularyValuesResult,
	type GetAttributeVocabularyValuesRequestOptions,
} from '../getAttributeVocabularyValues';
export * from '../getAttributeVocabularyValues';

export type GetAttributeVocabularyValuesResultInfiniteData =
	InfiniteData<GetAttributeVocabularyValuesResult>;

// page params are handled via the infinite query `pageParams`
export type GetAttributeVocabularyValuesQueryParams = Omit<
	GetAttributeVocabularyValuesRequestOptions,
	'startIndex' | 'stopIndex'
>;

export type GetAttributeVocabularyValuesQueryKey = [
	string,
	GetAttributeVocabularyValuesQueryParams,
];

export type GetAttributeVocabularyValuesQueryOptions = Omit<
	UseInfiniteQueryOptions<
		GetAttributeVocabularyValuesResult,
		QueryError,
		GetAttributeVocabularyValuesResult,
		GetAttributeVocabularyValuesResult,
		GetAttributeVocabularyValuesQueryKey
	>,
	'queryKey' | 'queryFn'
>;

export const GetAttributeVocabularyValuesReactQueryKey =
	getAttributeVocabularyValuesEndpoint;

/**
 * react-query wrapper for `getAttributeVocabularyValues`
 * @param queryKeyParams
 * @param options
 */
export const useReactQueryGetAttributeVocabularyValues = (
	queryKeyParams: GetAttributeVocabularyValuesQueryParams,
	options?: GetAttributeVocabularyValuesQueryOptions,
) =>
	useInfiniteQuery<
		GetAttributeVocabularyValuesResult,
		QueryError,
		GetAttributeVocabularyValuesResult,
		GetAttributeVocabularyValuesQueryKey
	>({
		queryKey: [getAttributeVocabularyValuesEndpoint, queryKeyParams],
		queryFn: ({queryKey, pageParam, signal}) =>
			getAttributeVocabularyValues({...queryKey[1], ...pageParam}, signal),
		...options,
	});

export default useReactQueryGetAttributeVocabularyValues;
